module.exports = __webpack_public_path__ + "static/ACTIVE_1992_2006.70fe5fef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/images/project2/ACTIVE_1992_2006.jpg
// module id = 492
// module chunks = 8418805283199